import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00031 } from '../../../../P00031';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import {
  getTemperature,
  getTemperatureUnit,
} from '../../../../../../helper/temperature';

@Component({
  selector: 'app-p00032-card-sens-statut',
  templateUrl: './p00032-card-sens-statut.component.html',
  styleUrls: ['./p00032-card-sens-statut.component.scss'],
  standalone: true,
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P00032CardSensStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];

  constructor() {}

  choixPhCouleur = (v: number) => {
    if (v < 4.9) return 'color-red';
    if (v > 9.1) return 'color-red';
    else return 'color-green';
  };

  getTemperatureContent() {
    return this.actionStack!.getValue('snSValiditeTemperatureEau') == 1
      ? getTemperature(
          this.actionStack!.getValue('snSMesureTemperatureEau') / 10,
        )
      : '--' + getTemperatureUnit();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P00039.card.state.lighting.title.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P00039.card.state.lighting.title.on',
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
        status: 'active',
      },
      {
        title: 'P00039.card.state.lighting.title.clock',
        icon: 'fa-kit fa-picto-horloge',
        color: 'color-orange',
        status: 'inactive',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.SENSE,
      FunctionOnglet.STATUS,
      this.translateService.instant('dashboard.mesure'),
    );
  }
}
